import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { Label } from 'Components/Label';
import { PickerOption } from 'Containers/SerializedEquipment/types';

import classes from './roomPicker.module.css';

interface Props {
  projects: PickerOption[];
  locations: PickerOption[];
  rooms: PickerOption[];
  projectId: string;
  locationId: string;
  roomId: string;
  loadingLocations: boolean;
  loadingRooms: boolean;
  onProjectChange: (e: any) => void;
  onLocationChange: (e: any) => void;
  onRoomChange: (e: any) => void;
}

function options(items: PickerOption[]) {
  return items.map((item) => (
    <option key={item.id} value={String(item.id)}>
      {item.label}
    </option>
  ));
}

function RoomPicker({
  projects,
  locations,
  rooms,
  projectId,
  locationId,
  roomId,
  loadingLocations,
  loadingRooms,
  onProjectChange,
  onLocationChange,
  onRoomChange,
}: Props) {
  return (
    <div className={classes.picker}>
      <div className={classes.field}>
        <Label ariaLabel="Project" className={classes.label} htmlFor="deployProject">
          Project
        </Label>
        <select
          id="deployProject"
          className="form-select"
          value={projectId}
          aria-label="Project"
          onChange={onProjectChange}
        >
          <option value="">Select a project…</option>
          {options(projects)}
        </select>
      </div>

      <div className={classes.field}>
        <Label ariaLabel="Location" className={classes.label} htmlFor="deployLocation">
          Location
        </Label>
        <select
          id="deployLocation"
          className="form-select"
          value={locationId}
          aria-label="Location"
          disabled={!projectId || loadingLocations}
          onChange={onLocationChange}
        >
          <option value="">{loadingLocations ? 'Loading…' : 'Select a location…'}</option>
          {options(locations)}
        </select>
      </div>

      <div className={classes.field}>
        <Label ariaLabel="Room" className={classes.label} htmlFor="deployRoom">
          Room
        </Label>
        <select
          id="deployRoom"
          className="form-select"
          value={roomId}
          aria-label="Room"
          disabled={!locationId || loadingRooms}
          onChange={onRoomChange}
        >
          <option value="">{loadingRooms ? 'Loading…' : 'Select a room…'}</option>
          {options(rooms)}
        </select>
      </div>
    </div>
  );
}

const RoomPickerMemo = memo(RoomPicker, areEqual);

export { RoomPickerMemo as RoomPicker };
